import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import commonApi from "@/api/commonApi";
import accountApi from "@/api/accountApi";
import userApi from "@/api/userApi";
import env from "@/config/env"
import javaApi from './api/javaApi';
import { setBindToken, getBindToken, removeBindToken, setToken, setUserId, getUserId, isWeiXin } from '@/libs/util'

Vue.use(Router)

const routerIns = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/', // 首页
      name: 'home',
      component: () => import('./views/home/index.vue'),
      meta: {
        hasNav: true, // 是否显示底部nav
        navIndex: 0, // 底部nav显示标记
        needLogin: true,
        keepAlive: true
      }
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('./views/download.vue')
    },
    {
      path: '/income-detail', // 收益详情  
      name: 'incomeDetail',
      component: () => import('./views/home/incomeDetail.vue'),
      meta: {
        needLogin: true
      }
    }, 
    // {
    //   path: '/home/member-relation', // 会员关系  
    //   name: 'memberRelation',
    //   component: () => import('./views/member/relation.vue'),
    //   meta: {
    //     hasNav: true, // 是否显示底部nav
    //     navIndex: 1 // 底部nav显示标记
    //   }
    // }, 
    {
      path: '/myuser/home',   //   我的信息-主页    
      name: 'myUserHome',
      component: () => import('./views/myuser/myUserHome.vue'),
      meta: {
        needLogin: true,
        hasNav: true, // 是否显示底部nav
        navIndex: 1, // 底部nav显示标记
        needLogin: true,
        keepAlive: true
      }
    }
    , {
      path: '/myuser/pouch',   //   我的-钱包    
      name: 'pouch',
      component: () => import('./views/myuser/mypouch/pouch.vue'),
      meta: {
        needLogin: true
      }
    }
    , {
      path: '/myuser/pouch/binding-card',   //   我的-钱包-绑定银行卡    
      name: 'bindingCard',
      component: () => import('./views/myuser/mypouch/bankcard/bindingCard.vue'),
      meta: {
        needLogin: true,
        keepAlive: true  // true 缓存
      }
    }
    , {
      path: '/myuser/pouch/bound-card',   //   我的-钱包-绑定银行卡(已绑定)    
      name: 'boundCard',
      component: () => import('./views/myuser/mypouch/bankcard/boundCard.vue'),
      meta: {
        needLogin: true
      }
    }
    , {
      path: '/myuser/pouch/binding-result',   //   我的-钱包-银行卡绑定结果    
      name: 'bindingResult',
      component: () => import('./views/myuser/mypouch/bankcard/bindingResult.vue'),
      meta: {
        needLogin: true
      }
    }
    , {
      path: '/myuser/pouch/agreement',   //   我的-钱包-用户协议    
      name: 'bankCardAgreement',
      component: () => import('./views/myuser/mypouch/bankcard/agreement.vue'),
      meta: {
        needLogin: true
      }
    }
    // , {
    //   path: '/myuser/pouch/recharge',   //   我的-钱包-充值    
    //   name: 'recharge',
    //   component: () => import('./views/myuser/mypouch/recharge/recharge.vue'),
    //   meta: {
    //     needLogin: true
    //   }
    // }
    // , {
    //   path: '/myuser/pouch/line-lower-recharge',   //   我的-钱包-线下充值    
    //   name: 'lineLowerRecharge',
    //   component: () => import('./views/myuser/mypouch/recharge/lineLowerRecharge.vue'),
    //   meta: {
    //     needLogin: true
    //   }
    // }
    // , {
    //   path: '/myuser/pouch/pouch-recharge-record',   //   我的-钱包-线下充值记录    
    //   name: 'pouchRechargeRecord',
    //   component: () => import('./views/myuser/mypouch/recharge/rechargeRecord.vue'),
    //   meta: {
    //     needLogin: true
    //   }
    // }
    , {
      path: '/myuser/pouch/bill',   //   我的-钱包-账单    
      name: 'bill',
      component: () => import('./views/myuser/mypouch/bill/bill.vue'),
      meta: {
        needLogin: true
      }
    }, {
      path: '/myuser/pouch/billDetail',   //   我的-钱包-账单详情    
      name: 'billDetail',
      component: () => import('./views/myuser/mypouch/bill/billDetail.vue'),
      meta: {
        needLogin: true
      }
    }
    , {
      //   type: balance 余额、commission 收益
      path: '/myuser/pouch/transfer',   //   我的-钱包-转账   
      name: 'transfer',
      component: () => import('./views/myuser/mypouch/transfer.vue'),
      meta: {
        needLogin: true
      }
    }
    , {
      path: '/myuser/pouch/reflect',   //   我的-钱包-提现  
      name: 'reflect',
      component: () => import('./views/myuser/mypouch/reflect/reflect.vue'),
      meta: {
        needLogin: true
      }
    }
    , {
      path: '/myuser/pouch/reflect-record',   //   我的-钱包-提现记录   
      name: 'reflectRecord',
      component: () => import('./views/myuser/mypouch/reflect/reflectRecord.vue'),
      meta: {
        needLogin: true
      }
    }
    , {
      path: '/myuser/pouch/news-inspect',   //   我的-钱包-短信认证   
      name: 'newsInspect',
      component: () => import('./views/myuser/mypouch/payment/newsInspect.vue'),
      meta: {
        needLogin: true
      }
    }
    , {
      path: '/myuser/pouch/payment-password',   //   我的-钱包-设置支付密码  
      name: 'paymentPassword',
      component: () => import('./views/myuser/mypouch/payment/paymentPassword.vue'),
      meta: {
        needLogin: true
      }
    },
    {
      path: '/code-login',   //  登录 
      name: 'codeLogin',
      component: () => import('./views/login/codeLogin.vue')
    },
    , {
      path: '/login',   // 账号密码登录   
      name: 'Login',
      component: () => import('./views/login/passwordLogin.vue')
    },
    {
      path: '/login/setting-password',   // 登录过程中设置昵称  
      name: 'setPassword',
      component: () => import('./views/login/setPassword.vue'),
      meta: {
        needLogin: true,
      }
    },
    {
      path: '/login/forget',   // 登录过程中忘记密码  
      name: 'forget',
      component: () => import('./views/login/forget.vue')
    },
    {
      path: '/myuser/updatePassword',   //   我的-修改登录密码  
      name: 'updatePassword',
      component: () => import('./views/myuser/updatePassword.vue'),
      meta: {
        needLogin: true
      }
    },
    {
      path: '/myuser/team-performance',   //   我的-修改登录密码  
      name: 'teamPerformance',
      component: () => import('./views/myuser/teamPerformance.vue'),
      meta: {
        needLogin: true
      }
    },
    {
      path: '/bind-phone',   //  绑定手机   
      name: 'bindPhone',
      component: () => import('./views/login/bindPhone.vue')
    }
    , {
      path: '/user-agreement',   //  用户协议  
      name: 'userAgreement',
      component: () => import('./views/login/userAgreement.vue')
    }
    , {
      path: '/page',   //  单页 
      name: 'page',
      component: () => import('./views/page.vue'),
    },
    {
      path: '*',
      name: 'notFound',
      component: () => import("./views/notFound.vue"),
    }
  ]
})

// 19000000001 经销商
// 登录地址 http://api-t-ext.agui.com.cn:52001/user/token?user_id=16&token=H0Jw4SJM6UAXdxP4D9TlYEKYKBEDVyMt5QG59FPIzPzYjoDd7im089aGQyxOZs6n
// setUserId(16);
// setToken('H0Jw4SJM6UAXdxP4D9TlYEKYKBEDVyMt5QG59FPIzPzYjoDd7im089aGQyxOZs6n');


// 14077770002 金卡会员
// 登录地址 http://api-t-ext.agui.com.cn:52001/user/token?user_id=29&token=puPxxfVnVsKLeduQefrcBQTHan3rNxElGYw6Xoxi3V0HNHMO1HdLAUbxR0JtWQn8
// setUserId(29);
// setToken('puPxxfVnVsKLeduQefrcBQTHan3rNxElGYw6Xoxi3V0HNHMO1HdLAUbxR0JtWQn8');


// 14077770000 金卡会员
// 登录地址 http://api-t-ext.agui.com.cn:52001/user/token?user_id=18&token=rpKHI1F7nsJS3XZOZ6FUa5Vy9wtLBbpKOJaTJOwF4mauDHyo8tnvj8hPVvKIs1R5
// setUserId(18);
// setToken('rpKHI1F7nsJS3XZOZ6FUa5Vy9wtLBbpKOJaTJOwF4mauDHyo8tnvj8hPVvKIs1R5');


// 14077770001 金卡会员
// 登录地址 http://api-t-ext.agui.com.cn:52001/user/token?user_id=22&token=LLHHT7nfRRzklyvoQ9CWWDoztEyqLKymaVLrYlbfIX9jFHmwSDRHTQUK8p8dPcBf
// setUserId(22);
// setToken('LLHHT7nfRRzklyvoQ9CWWDoztEyqLKymaVLrYlbfIX9jFHmwSDRHTQUK8p8dPcBf');

export default routerIns;


routerIns.beforeEach((to, from, next) => {
  let userId = getUserId();

  setStoreSystemConfig();

  if (!userId) {//用户未登录
    console.log(to, to.meta.needLogin)
    if (to.meta.needLogin) {
      next({ name: 'Login' });
    } else {
      next();
    }

  } else {//用户已登录
    hasUserFunc(userId, function () {
      if (to.name == "Login") {
        next({ name: "myUserHome" });
      } else {
        next();
      }
    });
  }
});

async function hasUserFunc(userId, callback) {
  // 2026-10-14：整体包 try/catch/finally。
  // javaAxios 在 subCode != 200 时会 Toast 并 reject（例如 RepeatFilter 的
  // 「请勿频繁操作」、或后端 202 业务失败）。这些预加载一旦抛出，原来 callback()
  // 就永远不执行 —— 也就是 beforeEach 里的 next() 不执行，路由直接卡死
  // （与之前「白屏」同一类故障模式）。预加载失败只应降级，不该阻断导航。
  try {
    // 2026-10-22：每次导航都校验一次账号状态。
    // 后端 /user/login/info 在账号被禁用时返回 subCode=997，javaAxios 收到后会清登录态
    // 并跳登录页 —— 这样「登录后被管理员禁用」不必等用户手动刷新才失效。
    // 只多这一次轻量请求；userInfo / accountBank 仍沿用原来的「store 为空才拉」。
    await userApi.loginInfo();
    //获取用户信息
    if (store.state.userInfo.user_id === undefined) {
      let res = await javaApi.userInfo();
      store.commit('setUserObj', {
        phone: res.data.phone,
        realname: res.data.realname,
        user_id: userId,
        user_type_name: res.data.user_type_name,
        user_type: res.data.user_type,
        star_type: res.data.star_type,
      });
      //获取用户银行卡信息
      let res1 = await accountApi.accountBank();
      if (res1 && res1.id !== undefined) {
        store.commit('setAccountBankObj', res1);
      }
    }
  } catch (e) {
    console.warn('[router]登录态预加载失败，已放行导航：', e && e.subMsg ? e.subMsg : e);
  } finally {
    if (callback) callback();
  }
}

function setStoreUserInfoCallBack(callback) {
  let userId = getUserId();
  if (userId) {
    if (store.state.userInfo.user_id === undefined) { // 判断状态管理里面是否有用户基本信息
      userApi.loginInfo().then(res => {
        store.commit('setUserObj', {
          phone: res.phone,
          open_id: res.open_id,
          user_id: userId,
          user_level: res.user_level,
          user_type: res.user_type,
          invitation_code: res.invitation_code
        });
        callback();
      });
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 用户信息
async function setStoreUserInfo() {
  let userId = getUserId();
  if (userId) { // 用户已经登录
    if (store.state.userInfo.user_id === undefined) { // 判断状态管理里面是否有用户基本信息
      let res = await userApi.loginInfo();
      store.commit('setUserObj', {
        phone: res.phone,
        open_id: res.open_id,
        user_id: userId,
        user_level: res.user_level,
        user_type: res.user_type,
        invitation_code: res.invitation_code
      });
    }
  }
}


// 系统配置
async function setStoreSystemConfig() {
  if (store.state.systemConfig.bank_list === undefined) {
    let res = await commonApi.systemConfig();
    store.commit("setSystemObj", res);
  }
}

// 绑卡信息
async function setStoreAccountBank() {
  let userId = getUserId();
  if (userId) { // 用户已经登录
    if (store.state.accountBank.id === undefined) {
      let res = await accountApi.accountBank();
      if (res.id !== undefined) {
        store.commit('setAccountBankObj', res);
      }
    }
  }
}
